var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data.stats.length)?_c('b-table',{staticClass:"table-sm",attrs:{"size":"sm","striped":"","hover":"","responsive":"","items":_vm.data.stats,"fields":_vm.fields,"dark":_vm.dark}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }